import { SelectItem } from 'primeng/api';
import { CustomerData, ISecurityAccessRoleData, UserEntityFeatures } from '.';
import { Commodity } from './commodity';
import { SecurityAppActionType } from './security-app-action-type';
import { UserFocusEntity } from './user-focus-entity';
import { UserNotification } from './user-notification';

export interface User {
  userId: string;

  identUserId: string;
  name: string;
  carrierName: string;
  carrierScac: string;
  scacName: string;
  primaryCarrierId: string;
  userNotifications: UserNotification[];
  availableCarrierScacs: string[];
  availableCarrierScacsSelectItems: SelectItem[];
  carrierVisibilityTypes: string[];
  isCarrier: boolean;
  isShipper: boolean;
  isAdmin: boolean;
  isActive: boolean;
  securityAccessRoles: ISecurityAccessRoleData[];
  authorizedShippers: CustomerData[];
  authorizedShippersForMyPrimaryScac: CustomerData[];
  myCustomerContractedScacs: string[];
  focusEntity: UserFocusEntity;
  primaryCustomerId: string;
  canSetDefaultCommodity: boolean;
  selectedCommodity: Commodity;
  defaultCommodity: string;
  hasAgreedToTerms: boolean;
  isImpersonating: boolean;
  firstName: string;
  lastName: string;
  features: UserEntityFeatures;
  isBookingEligible: boolean;
}

export class UserModel implements User {
  constructor(init?: Partial<UserModel>) {
    Object.assign(this, init);
  }

  userId: string;
  identUserId: string;
  name: string;
  carrierName: string;
  carrierScac: string;
  scacName: string;
  primaryCarrierId: string;
  userNotifications: UserNotification[];
  availableCarrierScacs: string[];
  availableCarrierScacsSelectItems: SelectItem[];
  carrierVisibilityTypes: string[];
  isCarrier: boolean;
  isShipper: boolean;
  isAdmin: boolean;
  isActive: boolean;
  securityAccessRoles: ISecurityAccessRoleData[];
  authorizedShippers: CustomerData[];
  authorizedShippersForMyPrimaryScac: CustomerData[];
  myCustomerContractedScacs: string[];
  focusEntity: UserFocusEntity;
  primaryCustomerId: string;
  canSetDefaultCommodity: boolean;
  selectedCommodity: Commodity;
  defaultCommodity: string;
  hasAgreedToTerms: boolean;
  isImpersonating: boolean;
  firstName: string;
  lastName: string;
  features: UserEntityFeatures;
  isBookingEligible: boolean;

  hasSecurityAction(actionType: SecurityAppActionType): boolean {
    return this.securityAccessRoles
      ? this.securityAccessRoles.some((r) => r.appActions && r.appActions.some((a) => a.appActionId === actionType))
      : false;
  }
}
